import { useEffect, useState } from "react";

export type ScrollDirection = "up" | "down" | "none";

export function useScrollDirection(
  ref: React.RefObject<HTMLDivElement | null>
): ScrollDirection {
  const [direction, setDirection] = useState<ScrollDirection>("none");
  const [lastScrollTop, setLastScrollTop] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const handleScroll = () => {
      const current = el.scrollTop;

      if (current > lastScrollTop) {
        setDirection("down");
      } else if (current < lastScrollTop) {
        setDirection("up");
      }

      setLastScrollTop(current);
    };

    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [ref, lastScrollTop]);

  return direction;
}
